App.factory('popUpService', ['Config', '$mdDialog', function (Config, $mdDialog) {

    function PopUpService() {

        let self = this;

        self.showPopUp = function (config) {
            let ev = config.ev, head = config.head, content = config.content, text = config.text,
                target = config.target, reload = config.reload, hideButton = config.hideButton,
                clickOutsideToClose = config.clickOutsideToClose, error = config.error, hideClose = config.hideClose,
                tpl = config.tpl || 'info-small';
            let secondButton = null;
            if (config.secondButton) {
                secondButton = config.secondButton;
            }
            return $mdDialog.show({
                controller: PopUpInfoCtrl,
                templateUrl: Config.TEMPLATES_DIR + 'PopUp/' + tpl + '.html',
                targetEvent: ev,
                clickOutsideToClose: clickOutsideToClose,
                locals: {
                    reload: reload,
                    head: head,
                    content: content,
                    error: error,
                    button: {
                        text: text,
                        target: target
                    },
                    secondButton: secondButton,
                    hideButton: hideButton,
                    hideClose: hideClose
                }
            });
        };

        self.showPopUpBigInfo = function (ev, head, content, text, target) {
            let config = {
                ev: ev,
                head: head,
                content: content,
                text: text,
                target: target,
                tpl: 'info-big',
                clickOutsideToClose: false,
            };
            return self.showPopUp(config);
        };

        /**
         * Displays error popup adjusted by given configuration and extended by error information
         * @param error
         * @param config
         */
        self.showPopUpWithError = function (error, config) {
            config.tpl = config.tpl || 'info-big';
            config.error = parseError(error);
            self.showPopUp(config);
        };

        /**
         * Parse error response to info text
         * @param error
         * @returns {string}
         */
        function parseError(error) {
            console.log('[parseError]', 'error to parse', error);
            let toParse;

            if (error.headers && error.status && error.config) { // It is response
                toParse = error.data;
            } else {
                toParse = error;
            }

            if (angular.isObject(toParse)) {
                let keys = Object.keys(toParse);
                if (keys.length === 1) {
                    toParse = toParse[keys[0]];
                }
            }

            console.log('[parseError]', 'result to parse', toParse);

            return JSON.stringify(toParse);
        }

        PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals', '$state'];
        function PopUpInfoCtrl($scope, $mdDialog, locals, $state) {
            $scope.locals = locals;

            $scope.hide = function () {
                if ($scope.locals.reload) {
                    $state.reload();
                }
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                if ($scope.locals.reload) {
                    $state.reload();
                }
                $mdDialog.cancel();
            };

            $scope.confirm = function () {
                if ($scope.locals.reload) {
                    $state.reload();
                }
                $mdDialog.hide($scope.locals);
            };
        }
    }

    return new PopUpService();
}]);
